module.exports = __webpack_public_path__ + "img/Fast-food-combo.fba98faa.jpg";